import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { ArrowDownIcon } from 'lucide-react';
export function OfferSection() {
  const {
    formattedTime
  } = useCountdown();
  const checkoutUrl = 'http://checkout.sabores365.online/cart/59172040638545:1';
  return <section id="oferta" className="py-16 px-4 bg-white scroll-mt-10" data-id="element-72">
      <div className="max-w-3xl mx-auto bg-brand-cream rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-brand-gold relative overflow-hidden" data-id="element-73">
        {/* Ribbon */}
        <div className="absolute top-6 -right-12 bg-brand-red text-white font-bold py-1 px-12 rotate-45 shadow-md" data-id="element-74">
          OFERTA ESPECIAL
        </div>

        <div className="text-center mb-8" data-id="element-75">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-green mb-2" data-id="element-76">
            Acceso Completo al Programa
          </h2>
          <p className="text-lg text-gray-600" data-id="element-77">
            Guía Principal + 4 Bonos Exclusivos
          </p>
        </div>

        <div className="flex flex-col items-center justify-center mb-8" data-id="element-78">
          <p className="text-gray-500 text-xl line-through mb-2 font-medium" data-id="element-79">
            Precio Normal: $30,990 ARS
          </p>
          <div className="flex items-start" data-id="element-80">
            <span className="text-3xl font-bold text-brand-green mt-2 mr-1" data-id="element-81">
              $
            </span>
            <span className="text-6xl md:text-7xl font-bold text-brand-green" data-id="element-82">
              19,990
            </span>
            <span className="text-xl font-bold text-brand-green mt-auto mb-2 ml-2" data-id="element-83">
              ARS
            </span>
          </div>
          <p className="text-brand-red font-bold mt-2 animate-pulse" data-id="element-84">
            Oferta expira en: {formattedTime}
          </p>
        </div>

        <div className="flex justify-center mb-6" data-id="element-85">
          <ArrowDownIcon className="w-8 h-8 text-brand-gold animate-bounce" data-id="element-86" />
        </div>

        <a href={checkoutUrl} className="block w-full bg-brand-gold hover:bg-yellow-500 text-brand-green text-center font-bold text-xl md:text-2xl py-5 px-8 rounded-xl shadow-[0_8px_20px_rgba(212,168,67,0.4)] hover:shadow-[0_12px_25px_rgba(212,168,67,0.6)] transform hover:-translate-y-1 transition-all duration-300" data-id="element-87">
          OBTENER ACCESO INMEDIATO
        </a>

        <div className="mt-6 text-center text-sm text-gray-500 space-y-2" data-id="element-88">
          <p data-id="element-89">✓ Descarga inmediata</p>
          <p data-id="element-90">✓ Acceso desde cualquier dispositivo</p>
          <p data-id="element-91">✓ Disponible en minutos</p>
        </div>
      </div>
    </section>;
}